const H = {
  name: "Mexico",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3V6H17C18.1046 6 19 6.89543 19 8V11C20.1046 11 21 11.8954 21 13V16H22C23.1046 16 24 16.8954 24 18V21C24 22.1046 23.1046 23 22 23H2C0.895431 23 0 22.1046 0 21V18C0 16.8954 0.89543 16 2 16H3V13C3 11.8954 3.89543 11 5 11V8C5 6.89543 5.89543 6 7 6L8 6V3ZM13.1242 8H10.8753L9.14194 21H14.8576L13.1242 8ZM13 6H14V3H10V6L11 6V4H13V6ZM16.8579 21H22V18H16.4753L16.84 20.7357C16.8519 20.8246 16.8577 20.9129 16.8579 21ZM19 16V13H15.8086L16.2086 16H19ZM15.5419 11H17V8H15.1419L15.5419 11ZM7 11H8.45758L8.85758 8H7V11ZM8.19091 13H5V16H7.79091L8.19091 13ZM7.15949 20.7357L7.52425 18H2V21H7.14162C7.14178 20.9129 7.14763 20.8246 7.15949 20.7357Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Mexico
};
